import { type LoaderFunctionArgs, redirect } from 'react-router';
import ROUTES from '@/routes';
import { BRAND_STORAGE_KEY, BUILD_ENV } from '@/utils/constants';

export function authCatchallLoader({ request }: LoaderFunctionArgs) {
  const redirectPath = new URL(request.url).searchParams.get('redirect') ?? undefined;

  if (BUILD_ENV === 'embedded') {
    const brand: string = localStorage.getItem(BRAND_STORAGE_KEY) || '';
    return redirect(ROUTES.ONBOARD.$buildPath({ searchParams: { brand, redirect: redirectPath } }));
  }

  return redirect(ROUTES.AUTH.SIGN_IN.$buildPath({ searchParams: { redirect: redirectPath } }));
}
